import { SearchExistingUsers } from "@components/organism";
import { useAddAccount } from "@pages/addAccount/useAddAccount";

export function SearchUsers() {
     const {searchTerm, users, setSearchTerm, searchUsers, noUsers , loading} = useAddAccount();
    return (
        <div>
            <SearchExistingUsers
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                users={users}
                loading={loading}
                noUsers={noUsers}
                searchUsers={searchUsers}
                linkUser={true}
                selectExistingUser={() => {}}
            />
        </div>
    )
}